export const HR = {
  preparing_zip: "Priprema zip-a…",
  compressing: "Kompresija…",
  info_icon: "Jednom označeno kao dovršeno, dodatni članovi se ne mogu pridružiti ili dodati, a sve chat grupe će biti deaktivirane. Imajte na umu da će projekt, zajedno sa svim chat grupama i podacima, ostati dostupan u deaktiviranom stanju.",
  mark_is_done: "Jeste li sigurni da želite označiti projekt kao dovršen? Jednom označen, dodatni članovi se ne mogu pridružiti ili dodati, a sve chat grupe će biti deaktivirane. Imajte na umu da će projekt, zajedno sa svim chat grupama i podacima, ostati dostupan u deaktiviranom stanju.",
  mark_not_done: "Jeste li sigurni da želite ponovno otvoriti projekt? Jednom označen kao otvoren, dodatni članovi se mogu pridružiti ili dodati, a sve chat grupe će biti ponovno aktivirane.",
  mark_as_completed: "Označi projekt kao dovršen",
  room_completed: "Projekt dovršen",
  room_members: "Članovi projekta",
  deactivated_rooms: "Deaktivirani projekti",
  deactivated_chats: "Deaktivirani chati",
  completed_rooms: "Dovršeni projekti",
  request_to_join_a_room: 'Zahtjev za pridruživanje projektu',
  wants_to_rejoin_room: 'Username se želi ponovno pridružiti projektu Roomname.',
  invited_you_to_join_room: 'Username vas je pozvao da se pridružite projektu Roomname.',
  restart: "Ponovno pokretanje",
  update_text: "Dostupno je novo ažuriranje. Kliknite na ponovno pokretanje za instalaciju ažuriranja.",
  update_availble: "Ažuriranje dostupno",
  Loading: "Učitavanje...",
  logout: "Odjava",
  back: 'Natrag',
  company_list: "Popis tvrtki",
  followers: "Sljedbenici",
  followings: "Praćenja",
  article: "Članak",
  companies: "Tvrtke",
  one_to_one_chat: " Chat jedan na jedan",
  profile: "Profil",
  company: "Tvrtka",
  company_selection: "Odabir tvrtke",
  home: "Početna",
  contact: "Kontakt ",
  add_company: "Dodaj tvrtku ",
  add_project: "Dodaj projekt ",
  capacities: "Kapaciteti ",
  work_area: "Radno područje",
  company_services: "Usluge tvrtke",
  website: "Web stranica",
  search_contacts: "Pretraži kontakte",
  add_or_join_a_company: "Dodaj ili se pridruži tvrtki",
  follow: "Prati",
  following: "Praćenje",
  like: "Sviđa mi se",
  company_contacts: "Kontakt tvrtke",
  leave_the_company: "Napusti tvrtku",
  news: "Vijesti",
  earlier: "Ranije",
  action: "Akcija",
  another_action: "Druga akcija",
  something_else: "Nešto drugo",
  search: "Pretraži",
  search_rooms: "Pretraži projekte",
  search_articles: "Pretraži članke",
  contacts: "Kontakti",
  suggestions: "Prijedlozi",
  project_list: "Popis projekata",
  search_results: "Rezultati pretrage",
  add_or_join_project: "Dodaj ili se pridruži projektu",
  details: "Detalji",
  your_position_within_company:
    "Molimo odaberite svoju poziciju u tvrtki.",
  close_modal: "Zatvori",
  map: "Karta",
  or: "Ili",
  name: "Ime*",
  street: "Ulica*",
  house_number: "Kućni broj",
  postal_code: "Poštanski broj",
  city: "Grad*",
  opened_by: "Otvoreno od:",
  project_No: "Broj projekta: ",
  building_type: "Vrsta zgrade*",
  building_types: "Vrsta zgrade",
  add_join: "Dodaj/Pridruži se",
  mandatory_fiels: "*obavezna polja",
  invalid_fiels: "Ovo polje je obavezno",
  add_or_join_company: "Dodaj ili se pridruži tvrtki",
  name_of_the_company: "Naziv tvrtke",
  edit_company_details: "Uredi detalje tvrtke",
  branch_of_the_building_industry: "Grana građevinske industrije",
  corporate_form: "Pravni oblik",
  position_within_company: "Pozicija u tvrtki",
  request_confirmation: "Na čekanju zahtjevi za projekte",
  company_e_mail: "E-mail tvrtke",
  type_of_filter: "Upišite za filtriranje...",
  setting: "Postavka",
  dashboard: "Nadzorna ploča",
  settings: "Postavke",
  views: "Pregledi",
  times_seen: "puta pregledano",
  see_more: "...više",
  see_less: "...manje",
  in_search: "u pretrazi",
  reset_password: "Resetiraj lozinku",
  submit: "Pošalji",
  password: "Lozinka",
  email: "E-mail",
  confirm_password: "Potvrdi lozinku",
  reset_email: "Resetiraj e-mail",
  update: "Ažuriraj",
  new_email: "Novi e-mail",
  kjuup_message: "Kjuup Poruka",
  delete_profile: "Izbriši profil?",
  my_position: "Moja pozicija:",
  add: "dodaj",
  owner_company_admin: "Administrator tvrtke :",
  owner_company_admin_new: "Administrator tvrtke",
  mutual_contact: "zajednički kontakt",
  mutual_contacts: "zajednički kontakti",
  co_owner: "Suosnivač",
  managing_director: "Upravni direktor",
  associate: "Suradnik",
  secretary: "Tajnik",
  employee: "Zaposlenik",
  project_manage: "Voditelj projekta",
  auto_chat_translation: "Automatsko prevođenje chata",
  translate_room_group_names: "Prevedi nazive grupa za chat",
  translate_room_group_names_info: "Kada je uključeno, nazivi grupa za chat automatski se prevode na jezik sučelja.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Kada je omogućeno, kartica E-Mail otvorit će se prema zadanim postavkama umjesto Poruka prilikom otvaranja aplikacije.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Jezik",
  english: "Engleski",
  german: "Njemački",
  french: "Francuski",
  italian: "Talijanski",
  change_language: "Promijeni jezik",
  my_companies: "Moje tvrtke",
  employees: "Zaposlenici",
  invite_with_a: "Pozovi u Kjuup",
  add_member: "Dodaj člana",
  add_user: "Dodaj korisnika",
  send_location: "Pošalji lokaciju",
  assign_admin_rights: "Podesi administratorska prava",
  deactivate_company: "Deaktiviraj tvrtku",
  remove_employees: "Ukloni zaposlenike",
  remove_members: "Ukloni članove",
  no_user_found: "Korisnik nije pronađen!",
  approve: "Odobri!",
  deselect_all: "Poništi odabir svega",
  select_all: "Odaberi sve",
  translation_on_building_projects: "Prevođenje u projektima",
  reported_capacities: "Prijavljene usluge",
  up_to_50m_exact: "Do 50m točno",
  company_details_service: "Usluge tvrtke",
  company_contact: "Kontakt tvrtke",
  invite_with_link: "Pozovi u Kjuup",
  share_link: "Podijeli poveznicu",
  share_company_link: "Podijeli poveznicu",
  qr_code: "QR kod",
  copy_link: "Kopiraj poveznicu",
  cancel_link: "Otkaži poveznicu",
  who_has_confirmed_services: "Tko je potvrdio vaše usluge?",
  projectss: "Projekti",
  add_services: "Dodaj usluge",
  services: "Usluge",
  save_text: "Spremi",
  share_on: "Podijeli na:",
  articlen: "Članak",
  invite_user_to_confirm_service:
    "Pozovite korisnike da potvrde usluge tvrtki.",
  link_copied: "Poveznica kopirana!",
  email_copied: "E-mail kopiran!",
  personal_article: "Osobni članak",
  company_article: "Članak tvrtke",
  characters_remaining: "Preostali znakovi",
  optional_information: "Neobavezne informacije",
  project: "Projekt",
  projects: "Projekti...",
  abort: "Odbaci",
  preview: "Pregled",
  post: "Objavi",
  of: "od",
  remove: "Ukloni",
  free_capacity: "Portal za posao",
  current_status_overview: "Pregled trenutnog statusa",
  report_capacities: "Prijavi usluge",
  report_text: "Prijavi",
  search_capacities: "Pronađi izvođače",
  add_project_user: "Dodaj korisnika projekta",
  media: "Mediji",
  links: "Veze",
  docs: "Dokumenti",
  featured_products: "Istaknuti proizvodi...",
  title: "Naslov",
  text: "Tekst",
  feed_details: "Detalji feeda",
  add_employee: "Dodaj zaposlenika",
  latest: "Najnovije",
  my_projects: "Moji projekti",
  cancel: "Otkaži",
  continue: "Nastavi",
  role_in_the_building_industry: "Uloga u građevinskoj industriji",
  als: "kao",
  join: "pridruži se",
  find: "Pronađi",
  request_to_join_a_company: "Zahtjev za pridruživanje tvrtki",
  wants_to_join_the_company: "želi se pridružiti tvrtki",
  filter_by: "Filtriraj po",
  ok: "Ok",
  close: "Zatvori",
  weekly_statistics: "Tjedne statistike",
  is_following_you: "vas prati.",
  as: "kao",
  has_joined_the: "se pridružio tvrtki",
  has_looked_at_your_profile: "je pogledao vaš profil.",
  time: "Vrijeme",
  in_searches_in_past_week: "u pretrazi prošli tjedan.",
  has_liked_your_article: "je lajkao vaš članak.",
  has_published_a_new_article: "je objavio novi članak.",
  you: "Vi",
  all_views: "Svi pregledi",
  all_profile_views: "Svi pregledi profila",
  mutual_company: "zajednička tvrtka",
  artical_text: "Napiši članak...",
  you_have_appeared: "Pojavili ste se",
  your_request_at_the_company: "Vaš zahtjev u tvrtki",
  times_you_have_appeared_in_searches: "puta ste se pojavili u pretrazi",
  appear_more_often_in_searches: "Pojavljujte se češće u pretrazi",
  you_have_been_found: "Pronađeni ste",
  improve_profile: "Poboljšaj profil",
  choose_existing_contact_for_single_chat:
    "Odaberite postojeći kontakt za pojedinačni chat:",
  in_order_to_add_new_contacts:
    "Da biste dodali nove kontakte, molimo pretražite nove kontakte na stranici profila.",
  times_in_searches_in_the_last_week:
    "puta u pretrazi prošli tjedan. Ažurirajte svoj profil i dodajte dodatne detalje kako biste bili lakše pronađeni.",
  has_been_confirmed: "je potvrđeno.",
  have_joined_the: "se pridružili  ",
  building_project: " građevinski projekt.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Odaberite tvrtku koju ćete predstavljati. Ovo će biti prikazano ostalim sudionicima.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Odaberite tvrtku koju ćete predstavljati. Ovo će biti prikazano ostalim sudionicima.",
  select_internal_section: "Molimo odaberite interni odjeljak",
  select_profile_image: "Odaberi sliku profila",
  share_user: "Podijeli korisnika",
  contact_sender_message:
    "Podijelite ovu poveznicu kako biste pozvali ne-člana Kjuup-a u Kjuup. Ova poveznica može se koristiti od više ljudi za registraciju.",
  project_sender_message:
    "Podijelite ovu poveznicu kako biste pozvali ne-člana Kjuup-a u projekt naziv projekta. Ova poveznica može se koristiti od više ljudi za registraciju i pridruživanje projektu naziv projekta u Kjuup-u.",
  company_sender_message:
    "Podijelite ovu poveznicu kako biste pozvali ne-člana Kjuup-a u tvrtku naziv tvrtke. Ova poveznica može se koristiti od više ljudi za registraciju i pridruživanje tvrtki u Kjuup-u.",
  contact_receivers_message:
    "Poveznica poziva za pridruživanje Kjuup-u. Molimo kliknite na poveznicu za registraciju u kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "U slučaju da instalirate Kjuup preko Apple App Store-a, morate kliknuti na ovu poveznicu nakon uspješnog preuzimanja, kako biste se mogli registrirati.",
  project_receivers_message:
    "Poveznica poziva za pridruživanje projektu naziv projekta u Kjuup-u. Molimo kliknite na poveznicu za registraciju u Kjuup i pridruživanje projektu naziv projekta.",
  company_receivers_message:
    "Poveznica poziva u tvrtku naziv tvrtke u Kjuup-u. Molimo kliknite na poveznicu za registraciju u Kjuup i pridruživanje tvrtki naziv tvrtke.",
  sign_in: "Prijava",
  enter_your_email_add: "Unesite vašu e-mail adresu",
  forgot_password: "Zaboravljena lozinka",
  dont_have_account: "Nemate račun?",
  register: "Registracija",
  get_app: "Preuzmi aplikaciju",
  registration: "Registracija",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arhitekt",
  prof: "Prof.",
  first_name: "Ime",
  last_name: "Prezime",
  have_an_account: "Imate račun?",
  when_register_you_agree: "Prilikom registracije pristajete na naše",
  term_of_use: "uvjete korištenja",
  to: ".",
  in_our: "U našoj",
  data_policy: "politici podataka",
  they_find_out: "saznajete,",
  we_provide_store_data: "kako prikupljamo, obrađujemo i pohranjujemo informacije.",
  leaving_company_text:
    "Želite li stvarno napustiti tvrtku? Kada napustite tvrtku, također napuštate sve povezane projekte i chat grupe. Možete se ponovno pridružiti tim projektima s drugom tvrtkom bilo kada.",
  delete_profile_text:
    "Želite li stvarno izbrisati svoj profil? Kada izbrišete svoj profil, sve veze s tvrtkama, projektima i chatovima bit će uklonjene. Možete stvoriti novi profil bilo kada.",
  confirm: "Potvrdi",
  reject: "Odbij",
  requet_to_leave: "Zahtjev za napuštanje",
  choose: "Odaberi",
  your_add_member: "Dodaj člana",
  if_you: "u slučaju da",
  can_not_find: "ne možete pronaći svoj kontakt ovdje.",
  please_wait: "Molimo pričekajte..",
  imprint_gtc: "Impresum/Opći uvjeti",
  register_confirm_popup: "Potvrdite svoju Kjuup e-mail adresu prije prijave. Poslali smo poveznicu za potvrdu. Ako je ne vidite, provjerite i mapu neželjene pošte.",
  PENDING_GROUP_USER:
    "će primati poruke tek nakon što je poziv u projekt potvrđen. Dodatna poruka će se pojaviti nakon što je poziv u projekt potvrđen.",
  PENDING: "Potvrda poziva u projekt na čekanju",
  denied_group_chat: " je odbio poziv u projekt i napustio ovu grupu.",
  // joined_group_chat: " se pridružio sobi i ovoj grupi.",
  joined_group_chat: " se pridružio ovoj grupi",
  you_joined_group_chat: "Pridružili ste se ovoj grupi.",
  Others: "Ostali",
  LEFT_GROUP: "je napustio ovu chat grupu.",
  YOU_LEFT_GROUP: "ste napustili ovu chat grupu.",
  days: "dana",
  day: "dan",
  hour: "sat",
  hide_project: "Sakrij projekt",
  hide_project_popup_text:
    "Ako sakrijete projekte, ne mogu se pronaći u Kjuup-u. Samo članovi projekta mogu pozvati nove korisnike u projekt.",
  branch: "Grana",
  photo_video_media_lib: "Medijska knjižnica - Fotografije i video",
  document: "Dokument",
  location_meeting: "Lokacija / Sastanak",
  all_member_of_project: "Svi članovi projekta",
  pending_request: "Na čekanju zahtjevi za projekte",
  no_pending_request: "Nisu pronađeni zahtjevi na čekanju!",
  news_feed: "Vijesti",
  user_info: "Informacije o grupi",
  leave_project: "Napusti projekt",
  media_link_docs: "Datoteke",
  search_chat: "Pretraži chat",
  export_chat_group: "Izvezi podatke chat grupe iz prošlog mjeseca",
  request_complete_chat_history: "Zatraži kompletnu povijest chata",
  leave_chat_group: "Napusti chat grupu",
  add_user_project: "Dodaj korisnika",
  me: "Ja",
  max_open_one_to_one:
    "Trenutno se mogu otvoriti max. 2 chata jedan na jedan paralelno u donjem i gornjem dijelu. Ukupno je moguće max. 4 chata jedan na jedan.",
  are_you_sure_you_want_leave_chat:
    "Jeste li sigurni da želite napustiti ovu chat grupu?",
  create_group: "Stvori grupu",
  adding_members: "Dodavanje članova...",
  creating_the_chat: "Kreiranje razgovora...",
  finishing_setup: "Završavanje...",
  group_name: "Naziv grupe",
  by: "Od:",
  mandetory: "*obavezno",
  delteed: "je izbrisao/la svoj profil i napustio/la grupni chat.",
  deleted_direct: "je izbrisao/la svoj profil i napustio/la chat.",
  unhidden_message:
    "Ako otkrijete projekte, mogu ih pronaći svi članovi Kjuup-a.",
  account_deleted: "Račun je izbrisan.",
  refuse_company: "Jeste li sigurni da želite odbiti poziv tvrtke?",
  follow_additional: "Prati dodatne korisnike",
  f_add:
    "Pratite dodatne korisnike Kjuup-a kako biste ih učinili dostupnima za izravne poruke.",
  c_inv: "Poziv(i) tvrtke",
  invited_o_Company: "Pozvani ste da se pridružite tvrtki",
  refuse_companyX: "Jeste li sigurni da želite odbiti zahtjev tvrtke?",
  a_Da: "Račun deaktiviran.",
  has_deactivated: "je deaktivirao/la svoj profil.",
  reactive: "je ponovno aktivirao/la svoj profil.",
  juup_note: "*Registracija s korisničkim imenom dostupna samo za članove Kjuup+",
  username: "Korisničko ime*",
  email_username: "E-mail/Korisničko ime*",
  sPinText:
    "Molimo unesite 6-znamenkasti sigurnosni PIN. Ovaj PIN će biti potreban u slučaju da zaboravite lozinku i obavezan je za potvrdu vašeg računa.",
  DeleteKjuupPlusText:
    "Želite li stvarno izbrisati svoj profil? Kada izbrišete svoj profil, sve veze s tvrtkama, projektima i chatovima bit će uklonjene.\n\nUnutar 48 sati nakon brisanja računa možete ponovno aktivirati svoj račun prijavom s korisničkim imenom, lozinkom i PIN-om.",
  reactive_text:
    "Vaš račun je izbrisan. Molimo kliknite na Ponovno aktiviraj za ponovnu aktivaciju vašeg računa.",
  rac: "Ponovno aktiviraj",
  ac_ss: "Račun je uspješno ponovno aktiviran.",
  not_valid_pin: "PIN nevažeći",
  only_for_kjuup:
    "*Resetiranje lozinke putem korisničkog imena i PIN-a dostupno samo za članove Kjuup+.",
  resetPIN: "Resetiraj PIN",
  enter_current_pin: "Molimo unesite svoj trenutni PIN",
  enter_new: "Unesite novi PIN",
  pin_to_confirm: "Molimo unesite PIN za potvrdu.",
  change_username: "Resetiraj korisničko ime",
  pp_not_match: "Lozinka i Potvrda lozinke se ne podudaraju",
  reactive_itself: "Ponovno ste aktivirali svoj profil.",
  has_deactivated_itself: "Deaktivirali ste svoj profil.",
  more_than_two:
    "Trenutno se izravne poruke mogu slati samo s 2 korisnika paralelno.",
  Chats: "Izravne poruke",
  only_in_mobileL:
    "Izvorni videozapisi se trenutno mogu učitati i objaviti samo putem mobilne aplikacije. Molimo koristite video veze Youtube-a i Vimea.",
  register_pin_text:
    "Molimo odaberite svoj osobni 6-znamenkasti PIN. Ovaj PIN će biti potreban za omogućavanje funkcija resetiranja računa.",
  internal_project: "Interni",
  external_projects: "Eksterni",
  in_deacticted: "Interni odjeljak je deaktiviran.",
  create_article: "Stvori članak",
  new_article_selection: "Stvori članak za vanjski feed vijesti",
  new_article_selection_internal: "Stvori interni članak",
  active_trans_title: "Uključiti automatsko prevođenje?",
  active_trans: "Kada je uključeno, sve dolazne poruke u chatu bit će prevedene na odabrani jezik aplikacije.",
  disable_trans: "Želite li stvarno deaktivirati automatsko prevođenje?",
  allow_access_chat: "Prikaži kompletnu povijest chata",
  toggle_chat_history_on:
    "Želite li stvarno da korisnik vidi kompletnu povijest chata?",
  toggle_chat_history_off:
    "Želite li stvarno da korisnik vidi samo povijest chata od trenutka pridruživanja chatu?",
  check_selected_settings:
    "Molimo provjerite postavke za povijest chata za sve odabrane korisnike!",
  chat_from_start_have:
    "Pridružili ste se ovoj grupi. Povijest chata je podijeljena.",
  chat_from_start_has:
    "se pridružio ovoj grupi. Povijest chata je podijeljena.",
  Address: "Adresa",
  read_by: "Pročitano",
  deliver_to: "Dostavljeno",
  remaining: "preostalo",
  message_info: "Informacije o poruci",
  request_to_join_only: "Zahtjev za pridruživanje",
  unfollow: "Prestani pratiti",
  company_username: "Korisničko ime",
  month: [
    "Sij",
    "Velj",
    "Ožu",
    "Tra",
    "Svi",
    "Lip",
    "Srp",
    "Kol",
    "Ruj",
    "Lis",
    "Stu",
    "Pro",
  ],
  remove_my_admin_right: "Ukloni moja administratorska prava",
  makeEmp: "Želite li stvarno ukloniti administratorska prava tvrtke od korisnika?",
  remove_my_self:
    "Želite li stvarno ukloniti administratorska prava tvrtke sa svog računa?",
  makeAdmin: "Želite li stvarno dati korisniku administratorska prava tvrtke?",
  remove_member: "Ukloni člana",
  remove_following_confirm: "Želite li stvarno ukloniti {name} s popisa praćenih?",
  remove_follower_confirm: "Želite li stvarno ukloniti {name} s popisa vaših pratitelja? Ako ga/nju uklonite, neće biti obaviješten/a.",
  do_you_really_want_to_remove:
    "Želite li stvarno ukloniti korisničko ime iz tvrtke?",
  invite_all: "Pozovi sve članove tvrtke",
  invite_all_members: "Pozovi sve članove",
  mems: "Svi ostali članovi",
  dep_loc: "Odjel/Lokacija/Tim",
  depAdmin: "Administrator odjela",
  add_remove_admin: "Dodaj/Ukloni poziciju administratora tvrtke",
  add_remove_dep_admin: "Dodaj/Ukloni poziciju administratora odjela",
  remove_employees_dept: "Ukloni zaposlenike iz",
  want_to_join_dep:
    "Korisničko ime želi se pridružiti Odjelu/Lokaciji/Timu depname tvrtke companyname.",
  you_invited:
    "Pozvani ste da se pridružite Odjelu/Lokaciji/Timu depname tvrtke companyname.",
  dep_remove:
    "Želite li stvarno ukloniti administratorska prava za odjel ili lokaciju od korisnika?",
  add_dep:
    "Želite li stvarno dati korisniku administratorska prava za odjel ili lokaciju?",
  my_self_dep_remove:
    "Želite li stvarno ukloniti administratorska prava odjela sa svog računa?",
  member: "Član",
  admin: "Administrator",
  remove_project_admin:
    "Želite li stvarno ukloniti člana iz projekta?",
  remove_my_self_project: "Želite li stvarno ukloniti administratorska prava?",
  remove_member_admin_right:
    "Želite li stvarno ukloniti administratorska prava od korisnika?",
  add_member_admin_right: "Želite li stvarno dodati administratorska prava korisniku?",
  add_remove_Poss: "Dodaj/Ukloni poziciju administratora",
  forward: "Proslijedi",
  edit: "Uredi",
  only_kjuup_plus_can: "Samo tvrtke Kjuup+ mogu objavljivati članke.",
  add_images: "Dodaj sliku(e)",
  request_confirmation: 'Na čekanju pozivi u projekte',
  Activity: "Aktivnost",
  latest_messages: "Najnovije poruke",
  hours: "sati",
  minute: "minuta",
  seconds: "sekundi",
  days: "dana",
  yesterday: "jučer",
  last_week: "prošli tjedan",
  next_week: "sljedeći tjedan",
  Last_month: "prošli mjesec",
  All: "Svi",
  register_plus: "Registracija Plus",
  select_files: "Odaberi datoteke",
  monthsFullName: [
    "Siječanj",
    "Veljača",
    "Ožujak",
    "Travanj",
    "Svibanj",
    "Lipanj",
    "Srpanj",
    "Kolovoz",
    "Rujan",
    "Listopad",
    "Studeni",
    "Prosinac",
  ],
  company_deploc_receivers_message:
    "Poveznica poziva u odjel tvrtke naziv tvrtke u Kjuup-u. Molimo kliknite na poveznicu za registraciju u Kjuup i pridruživanje tvrtki naziv tvrtke.",
  no_news: "Nema dostupnih vijesti",
  reminder: "Podsjetnik",
  np_reminder: "Nema zadataka",
  move_to_reminder: "Premjesti u zadatak",
  remove_reminder: "Želite li stvarno ukloniti ovu poruku s popisa vaših zadataka?",
  remove_all_reminder: "Ukloni sve zadatke",
  remove_all_confirm: "Želite li stvarno ukloniti sve poruke s popisa vaših zadataka?",
  remove_from_reminder: "Ukloni iz podsjetnika",
  prevent_email: "E-mail se ne može koristiti kao Korisničko ime.",
  allow_noti: "Molimo dopustite obavijesti.",
  join_cap: "Pridruži se",
  pass_minimum:
    "**Lozinka zahtijeva 12 znakova uključujući malo slovo, veliko slovo, broj i poseban znak.",
  pass_error: "Molimo provjerite zahtjeve za lozinku",
  people_that_like_article: "Ljudi kojima se članak sviđa.",
  people_who_like_article: "Ljudi kojima se vaš članak sviđa.",
  message_delete: "Ova poruka je izbrisana.",
  message_edited: "uređeno",
  edit_message: "Uredi poruku",
  edit_window_expired: "Poruke se mogu uređivati samo unutar 10 minuta nakon slanja.",
  message_edit_save: "Spremi",
  copy: "Kopiraj",
  bookmark: "Knjižna oznaka",
  add_reaction: "Dodaj reakciju",
  delete_message: "Izbriši poruku",
  more_options: "Više opcija",
  info: "Info",
  link_invite: "Pozovi putem poveznice",
  ll_nkk: "Pozovi u Kjuup",
  selected: "Odabrano",
  is_active: "Aktivan",
  inactive: "Neaktivan",
  last_online: "zadnji put na mreži {{when}}",
  remove_user_l: "Ukloni",
  link_expire: "Svaka generirana poveznica bit će važeća 72 sata.",
  company_language: "Jezik tvrtke",
  company_language_info:
    "Odabir jezika koristit će se za sva e-mail potvrde vezana uz tvrtku.",
  s_image: "slika",
  m_image: "slike",
  removeMsg: "Dodirnite za uklanjanje",
  block: 'Blokiraj',
  unblock: 'Odblokiraj',
  blocks: 'Jeste li sigurni da želite blokirati ovog korisnika?',
  unblocks: 'Jeste li sigurni da želite odblokirati ovog korisnika?',
  bolcked_click_un_block:
    'Blokirali ste ovaj kontakt. Kliknite ovdje za uklanjanje blokade.',
  you_have_unblocked: 'Odblokirali ste ovaj kontakt.',
  you_have_blocked: 'Blokirali ste ovaj kontakt.',
  unblock_to_send: 'Odblokiraj korisnika za slanje poruke.',
  pilot_text: "Specijalizirana AI za građevinske teme",
  startup_screen_label: "Početni zaslon",
  startup_screen_info: "Odaberite koji se zaslon otvara pri pokretanju Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Poruke",
  startup_screen_saved: "Početni zaslon je ažuriran",
email_on: "E-mail obavijesti za chatove",
  email_on_grp: "E-mail obavijest",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivirajte ili deaktivirajte e-mail obavijesti za ovaj projekt. Ova opcija je dostupna samo kada je \"E-mail obavijesti za chatove\" omogućena putem osobnih postavki.",
  todo_notification_info: "Bit ćete obaviješteni svaki put kada vam se dodijeli novi zadatak.",
  info_val: "Primit ćete e-mail ako nova poruka u chatu ne bude pročitana u kratkom roku. To možete isključiti za pojedine projekte ili chatove u njihovim postavkama ili u informacijama chat grupe.",
  email_groups: "Aktivirajte ili deaktivirajte e-mail obavijesti za ovaj chat. Ova opcija je dostupna samo kada je \"E-mail obavijesti za chatove\" omogućena putem osobnih i postavki projekta.",
  add_update_email: "Dodaj/Ažuriraj e-mail",
  text_to_verifiy: "Opcija \"E-mail obavijesti za chatove\" može se omogućiti samo ako imate potvrđenu e-mail adresu u datoteci.",
  stored_email: "Pohranjeni e-mail: ",
  verify_email: "Potvrda na čekanju!",
  join_call:"Pridruži se",
  call_is_started:"Poziv je započet",
  start_chat:"Pokreni izravni chat?",
  project_rooms:"Projekti",
  download_selected:"Preuzmi",
  add_employee_confirm: 'Jeste li sigurni da želite dodati ovog korisnika u tvrtku?',
  invalid_deeplink: "Nevažeći URL dublje veze. Nedostaju potrebni parametri.",
  deeplink_error: "Nije moguće obraditi dublju vezu. Molimo pokušajte ponovno kasnije.",
  // Reply functionality translations
  reply: "Odgovori",
  reply_enter: "Unesite odgovor...",
  reply_sent_successfully: "Odgovor je uspješno poslan",
  reply_failed: "Slanje odgovora nije uspjelo",
  reply_failed_generic: "Slanje odgovora nije uspjelo. Molimo pokušajte ponovno.",
  replying_to_message: "Odgovaranje na poruku",
  cancel_reply: "Otkaži odgovor",
  voice_message: "Glasovna poruka",
  send: "Pošalji",
  cancel: "Otkaži",
  type_your_reply: "Upišite svoj odgovor...",
  
  // Auto-suggestion translations
  suggested_replies: "Predloženi odgovori",
  suggestions_error: "Učitavanje prijedloga nije uspjelo",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Trenutak. Vaš tekst se priprema individualno za vas.",
  loading_chat_message: "Učitavanje chata...",
  
  // Manual ToDo translations
  extracting_message: "Izdvajanje poruke...",
  create_todo: "Stvori zadatak",
  create_todo_confirmation: "Želite li stvoriti zadatak iz ove poruke?",
  select_project_required: "Molimo odaberite projekt/grupu",
  only_assigned_can_change_status: "Samo dodijeljeni korisnici mogu promijeniti status",
  todo_summary: "Sažetak",
  todo_summary_placeholder: "Unesite sažetak zadatka...",
  todo_date: "Datum",
  todo_time: "Vrijeme",
  todo_date_hint: "Ostavite prazno za korištenje datuma/vremena izvorne poruke",
  todo_created_success: "Zadatak je uspješno stvoren",
  todo_creation_failed: "Stvaranje zadatka nije uspjelo",
  create: "Stvori",
  
  image: "slika",
  images: "slike",
  remove_all_images: "Ukloni sve slike",
  remove_image: "Ukloni sliku",
  remove_document: "Ukloni dokument",
  remove_recording: "Ukloni snimku",
  play_recording: "Reproduciraj snimku",
  upload_image: "Učitaj sliku",
  upload_document: "Učitaj dokument",
  record_audio: "Snimi audio",
  stop_recording: "Zaustavi snimanje",
  stop_recording_text: "Zaustavi snimanje",
  please_remove_current_attachment: "Molimo uklonite trenutnu privitku za",
  please_upload_image_file: "Molimo učitajte valjanu sliku datoteke",
  please_upload_valid_document: "Molimo učitajte valjanu dokument datoteku",
  searching_messages: "Pretraživanje poruka...",
  loading_more: "Učitavanje više...",
  loading_more_users: "Učitavanje više korisnika...",
  load_more_users: "Učitaj više korisnika",
  no_more_users_to_load: "Nema više korisnika za učitavanje",
  no_messages_found: "Nisu pronađene poruke",
  try_different_keyword: "Pokušajte s drugom ključnom riječju ili provjerite svoj pravopis.",
  search_messages: "Pretraži poruke, grupe za chat, projekte i korisnike...",
  todo: "Zadatak",
  np_todo: "Nema zadataka",
  move_to_todo: "Spremi kao zadatak",
  remove_todo: "Želite li stvarno ukloniti zadatak?",
  remove_all_todo: "Ukloni sve zadatke",
  remove_all_todo_confirm: "Želite li stvarno ukloniti sve zadatke?",
  add_to_todo: "Dodaj u zadatak",
  remove_from_todo: "Ukloni iz zadatka",
  confirm: "Potvrdi",
  ok: "Ok",
  read_more: "Pročitaj više",
  show_less: "Prikaži manje",
  show_more: "Prikaži više",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  notification_schedule: "Raspored obavijesti",
  notification_schedule_desc: "Primat ćete push i e-mail obavijesti samo u satima koje odaberete. Izvan tih vremena bit će pauzirane.",
  learn_more: "Saznaj više",
  allow_notifications: "Dopusti obavijesti:",
  every_day: "Svaki dan",
  weekdays: "Radni dani (ponedjeljak do petak)",
  custom: "Prilagođeno",
  monday: "Ponedjeljak",
  tuesday: "Utorak",
  wednesday: "Srijeda",
  thursday: "Četvrtak",
  friday: "Petak",
  saturday: "Subota",
  sunday: "Nedjelja",
  to: "do",
  notification_settings: "Obavijesti",
  notification_settings_saved: "Postavke obavijesti su uspješno spremljene",
  notification_settings_error: "Spremanje postavki obavijesti nije uspjelo",
  unavailability_note: "Obavijest o nedostupnosti",
  unavailability_description: "Postavite obavijest o odsutnosti. Dok je aktivna, obavijest se prikazuje drugima u svim vašim razgovorima, a obavijesti su pauzirane.",
  unavailability_start_date: "Datum početka",
  unavailability_end_date: "Datum završetka",
  unavailability_message: "Poruka",
  unavailability_message_hint: "Koristite {endDate} kao zamjenski tekst za datum povratka.",
  unavailability_replacement: "Zamjenski kontakt",
  unavailability_replacement_placeholder: "Unesite ID korisnika za hitne zahtjeve",
  unavailability_replacement_current: "Trenutna zamjena",
  unavailability_replacement_hint: "Ako je postavljeno, u obavijesti o nedostupnosti bit će prikazan link za kontaktiranje ove osobe za hitne stvari.",
  unavailability_replacement_none: "Bez zamjene (neobavezno)",
  unavailability_contact_urgent: "Za hitne zahtjeve kontaktirajte",
  unavailability_default_message: "Trenutno nisam u uredu i nemam pristup Kjuupu. Ponovno ću biti dostupan/na od {endDate} i tada ću vam se javiti.",
  unavailability_save: "Spremi",
  unavailability_deactivate: "Deaktiviraj",
  unavailability_active_until: "Aktivno do",
  unavailability_saved: "Obavijest o nedostupnosti spremljena",
  unavailability_save_error: "Spremanje obavijesti o nedostupnosti nije uspjelo",
  unavailability_deactivated: "Obavijest o nedostupnosti deaktivirana",
  unavailability_end_date_required: "Datum završetka je obavezan",
  start_time_before_end_time: "Vrijeme početka mora biti prije vremena završetka",
  loading: "Učitavanje",
  disabled: "Onemogućeno",
  enable: "Omogući",
  disable: "Onemogući",
  forwarded: "Proslijeđeno",
  message_forwarded: "Poruka je proslijeđena!",
  // Schedule Article
  schedule_article_post: "Zakazati objavu članka",
  date: "Datum",
  time: "Vrijeme",
  scheduled_for_publication: "Zakazano za objavu",
  article_will_be_published_on: "Članak će biti objavljen:",
  reset_selection: "Resetiraj odabir",
  continue: "Nastavi",
  cancel: "Otkaži",
  // Member Selection
  error_loading_members: "Greška pri učitavanju članova",
  please_fill_all_fields: "Molimo ispunite sva polja",
  invalid_email: "Nevažeća e-mail adresa",
  member_added_successfully: "Član je uspješno dodan",
  error_onboarding_user: "Greška pri dodavanju korisnika",
  error_creating_chat: "Greška pri stvaranju chata",
  error_creating_group: "Greška pri stvaranju grupe",
  new_group: "Nova grupa",
  please_select_or_enter_group_name: "Molimo odaberite grupu ili unesite naziv grupe",
  please_select_or_enter_room_name: "Molimo odaberite projekt ili unesite naziv projekta",
  error_creating_room: "Greška pri stvaranju projekta",
  error_opening_chat: "Greška pri otvaranju chata",
  privacy_modal_text: "Odaberite \"Privatno\" samo ako chat ne sadrži relevantan profesionalni sadržaj za projektnog menadžera.",
  not_private: "Nije privatno",
  private: "Privatno",
  error_loading_groups: "Greška pri učitavanju grupa",
  automatic_chat_export: "Automatski izvoz chata",
  automatic_chat_export_info: "Nakon aktivacije, povijest chata će se automatski slati na navedenu e-mail adresu svaki mjesec.",
  automatic_chat_export_no_email: "Da biste omogućili automatski izvoz chata, prvo morate dodati e-mail adresu. Svoju e-mail adresu možete dodati u osobnim postavkama.",
  enter_email: "Unesite e-mail",
  update: "Ažuriraj",
  confirm: "Potvrdi",
  export_to_email: "Izvoz ide na sljedeći e-mail.",
  start_chat_button:"Nova poruka",
  matching_existing_chats: "Usklađeni postojeći chati",
  subject: "Predmet",
  add_subject: "Dodaj predmet",
  chat_subject: "Predmet chata:",
  set_project_room: "Postavi projekt",
  matching_existing_project_rooms: "Usklađeni postojeći projekti",
  name_project_room: "Imenuj projekt",
  professional_or_private: "Profesionalno ili privatno",
  professional: "Profesionalno",
  privacy_modal_text_updated: "Odaberite \"Privatno\" samo ako chat ne sadrži relevantan profesionalni sadržaj za projektne menadžere. Privatni chati nisu vidljivi projektnim menadžerima.",
  create_internal_chat: "Vanjski - ili interni chat?",
  internal_chat_description: "Samo zaposlenici vaše tvrtke mogu se dodati u interne chatove.",
  yes: "Da",
  no: "Ne",
  chat_is_being_created: "Chat se stvara...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Želite li stvarno odbaciti promjene ovog članka?",
  please_enter_article_title: "Molimo prvo unesite naslov članka.",
  please_add_mandatory_fields: "Molimo dodajte sva obavezna polja",
  product_label: "Proizvod:",
  no_companies_found: "Nisu pronađene tvrtke",
  visible_to_all_followers: "Vidljivo svim članovima Kjuup",
  only_visible_to_employees: "Vidljivo samo zaposlenicima",
  something_went_wrong: "Nešto je pošlo po zlu, molimo pokušajte ponovno",
  please_select_department: "Molimo odaberite odjel/lokaciju",
  schedule: "Zakazati",
  please_select_future_date_time: "Molimo odaberite budući datum i vrijeme za zakazivanje članka.",
  please_select_different_date_time: "Molimo odaberite drugi datum ili vrijeme za zakazivanje članka.",
  please_select_later_time: "Molimo odaberite vrijeme kasnije od trenutnog vremena za danas.",
  unpin_article: "Otkači članak",
  pin_article: "Zakači članak",
  and: "i",
  others: "ostali",
  at: "u",
  // Chat mute/unmute translations
  mute: "Utišaj",
  unmute: "Otkrij glas",
  chat_muted_successfully: "Chat je uspješno utišan",
  chat_unmuted_successfully: "Utišavanje chata je uspješno otkazano",
  mute_chat_confirm: "Želite li stvarno utišati ovaj chat? Više nećete primati obavijesti za nove poruke.",
  unmute_chat_confirm: "Želite li stvarno otkazati utišavanje ovog chata? Ponovno ćete primati obavijesti za nove poruke.",
  please_select_group_to_forward: "Molimo odaberite grupu za prosljeđivanje poruke",
  // Company translations
  record_not_found: "Zapis nije pronađen!",
  please_select_position: "Molimo odaberite poziciju",
  delete_article_confirm: "Jeste li sigurni da želite izbrisati ovaj članak?",
  delete_company_service_confirm: "Jeste li sigurni da želite izbrisati uslugu tvrtke?",
  block_translation_confirm: "Želite li stvarno blokirati automatsko prevođenje u projektima za sve članove tvrtke",
  unblock_translation_confirm: "Želite li stvarno odblokirati automatsko prevođenje u projektima za sve članove tvrtke",
  please_select_file: "Molimo odaberite datoteku za učitavanje",
  role_in_building_industry: "Uloga u građevinskoj industriji*",
  invalid_email_address: "Nevažeća e-mail adresa",
  please_enter_password: "Molimo unesite lozinku",
  password_change_email_sent: "Na vašu Kjuup e-mail adresu poslan je e-mail. Potvrdite novu lozinku klikom na poveznicu za potvrdu u e-mailu.",
  please_enter_username: "Molimo unesite korisničko ime",
  username_same_as_before: "Korisničko ime ne može biti isto kao prije",
  profile_deleted_successfully: "Profil je uspješno izbrisan",
  hardware_requirements: "Zahtjevi za hardver",
  hardware_requirements_list: "• 4GB RAM<br/>• Brzina procesora min. 2GHz<br/>• Windows 7 ili noviji / sve verzije macOS",
  submitting: "Slanje...",
  signing_in: "Prijava...",
  please_enter_service_name: "Molimo unesite naziv usluge",
  something_went_wrong_error: "Aaaah! Nešto je pošlo po zlu...",
  something_went_wrong_try_again: "Oprostite, nešto je pošlo po zlu. Pokušajte ponovno",
  position_label: "Pozicija:",
  loading_room: "Učitavanje projekta...",
  navigating_to_room: "Navigacija u projekt",
  loading_chat: "Učitavanje chata...",
  translate: "Prevedi",
  show_original: "Prikaži original",
  saving: "Spremanje...",
  language_selection_info: "Odabir jezika koristi se za sve e-mail potvrde vezane uz tvrtku.",
  // Navigation bar labels
  nav_call: "Pozovi",
  nav_home: "Početna",
  nav_messages: "Poruke",
  nav_todo: "Zadaci",
  nav_rooms: "Projekti",
  nav_all_rooms: "Svi projekti",
  pinned_rooms_max: "Možete prikvačiti do 10 projekata.",
  pinned_room_unpin: "Otkvači",
  pinned_rooms_drop: "Povucite projekt ovdje za brzi odabir",
  nav_profile: "Profil",
  nav_company: "Tvrtka",
  nav_company_documents: "Dokumenti",
  nav_logout: "Odjava",
  // Create message dialog
  add_member_title: "Dodaj člana",
  continue_btn: "Nastavi",
  search_placeholder: "Pretraži",
  no_members_found: "Nisu pronađeni članovi",
  no_groups_found: "Nisu pronađene grupe",
  no_rooms_found: "Nisu pronađeni projekti",
  search_users_tab: "Korisnici",
  search_documents_tab: "Dokumenti",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Nema datoteka",
  no_documents_available: "No documents",
  searching_users: "Pretraživanje korisnika...",
  no_users_found: "Nije pronađen nijedan korisnik",
  search_emails_tab: "E-pošta",
  searching_emails: "Pretraživanje e-pošte...",
  no_emails_found: "Nije pronađena nijedna e-pošta",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Grupa bez naziva",
  unnamed_room: "Projekt bez naziva",
  all_members: "Svi",
  room_label: "Projekt:",
  subject_label: "Predmet:",
  no_members: "Nema članova",
  // Loading states for room creation
  creating_structure: "Stvaranje vaše strukture",
  opening_chat: "Otvaranje chata",
  please_wait: "Molimo pričekajte...",
  // ToDo page translations
  loading_todo: "Učitavanje ToDo...",
  task_updated: "Zadatak je ažuriran",
  error_updating_task: "Greška pri ažuriranju zadatka",
  task_deleted: "Zadatak je izbrisan",
  error_deleting_task: "Greška pri brisanju zadatka",
  delete_task_confirm: "Jeste li sigurni da želite izbrisati ovaj zadatak?",
  description_label: "Opis",
  description_placeholder: "Unesite opis...",
  date_time_label: "Datum i vrijeme",
  save_hint: "Ctrl+Enter za spremanje, Esc za otkazivanje",
  edit_label: "Uredi",
  delete_label: "Izbriši",
  todo_list_title: "Zadaci",
  tasks_count: "zadataka",
  search_placeholder_todo: "Pretraži...",
  select_task_to_open_chat: "Odaberite zadatak za otvaranje chata",
  today: "Danas",
  yesterday: "Jučer",
  time_suffix: "", // Empty for Croatian (24h format doesn't need suffix)
  from_chat: "Izvorni zadatak",
  assigned_to: "Dodijeljeno",
  assign_users: "Dodijeli korisnike",
  no_users_assigned: "Nema dodijeljenih korisnika",
  assign: "Dodijeli",
  assign_to: "Dodijeli...",
  navigate_to_chat: "Idi na chat",
  navigate_to_email: "Idi na e-poštu",
  show_original_message: "Prikaži izvor",
  hide_original_message: "Sakrij izvor",
  status_pending: "Na čekanju",
  status_in_progress: "U tijeku",
  status_completed: "Dovršeno",
  show: "Prikaži",
  close: "Zatvori",
  // Log translation strings
  status_confirmed: "[Potvrđeno]",
  log_todo_created: "Zadatak [stvoren]",
  log_todo_confirmed: "Zadatak [potvrđen]",
  log_todo_deleted: "Zadatak [izbrisan]",
  log_todo_updated: "Zadatak [ažuriran]",
  log_description_updated: "[Opis ažuriran]",
  log_deadline_updated: "[Rok ažuriran]",
  log_assigned_to: "[Dodijeljeno korisniku] {name}",
  log_unassigned_from: "[Uklonjena dodjela od] {name}",
  log_assignment_added: "[Dodjela dodana]: {name}",
  log_assignment_removed: "[Dodjela uklonjena]: {name}",
  log_status_updated: "[Status promijenjen iz] {from} [u] {to}",
  log_status_changed: "[Status promijenjen]",
  log_status_changed_to: "[Status promijenjen u] {status}",
  log_changed_status_to: "[Promijenio status u]:",
  log_for_user: "[za korisnika]:",
  log_user_updated_status: "[Korisnik je ažurirao svoj status zadatka]",
  log_changed_date_to: "[Promijenio datum u]:",
  log_changed_description_to: "[Promijenio opis u]:",
  log_moved_to: "[Premješteno u] {status}",
  todo_status_updated_from: "[iz]",
  todo_status_updated_to: "[u]",
  filter_pending: "Na čekanju",
  filter_confirmed: "Potvrđeno",
  filter_assigned_to_me: "Moji zadaci",
  filter_assigned_by_me: "Delegirano",
  todo_project_label: "Projekt:",
  assigned_users: "Dodijeljeni korisnici:",
  todo_chat_label: "Razgovor:",
  history: "Povijest",
  todo_assigned_by: "Dodijelio:",
  todo_assigned_push: "Dodijeljeno ToDo:",
  todo_assigned_push_empty: "Dodijeljen vam je novi ToDo.",
  search_groups: "Grupe",
  search_chat_groups: "Chat grupe",
  search_project_room: "Projekt",
  search_messages_tab: "Poruke",
  searching_groups: "Pretraživanje grupa...",
  searching_rooms: "Pretraživanje projekata...",
  no_groups_found: "Nema pronađenih grupa",
  no_rooms_found: "Nema pronađenih projekata",
  create_poll: "Anketa",
  poll_question_label: "PITANJE",
  poll_question_placeholder: "Postavite pitanje",
  poll_options_label: "OPCIJE",
  poll_option: "Opcija",
  poll_add_option: "Dodaj opciju",
  poll_allow_multiple: "Dopusti više odgovora",
  poll_multiple_allowed: "Odaberite jednu ili više opcija",
  poll_select_option: "Odaberite jednu opciju",
  poll_view_votes: "Pogledaj glasove",
  poll_vote_singular: "glas",
  poll_vote_plural: "glasova",
  poll_votes: "Rezultati glasovanja",
  poll_no_votes_yet: "Još nema glasova",
  transcript_step_processing: "Transkripcija u tijeku...",
  ai_transcript_tab: "AI-Transkripcija",
  ai_transcript_info: "Dostupno samo za glasovne poruke stvorene nakon 09.03.2026.",
  transcript_more: "...više",
  transcript_less: "...manje",
  ki_transcript_voice_message: "KI-Transkript glasovne poruke",
  ki_image_analysis: "AI analiza slike",
  type_message: "Unesite poruku",
  email_tab_messages: "Poruke",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-mail računi",
  email_connect_gmail: "Poveži Gmail",
  email_connect_outlook: "Poveži Outlook",
  email_no_accounts: "Nema povezanih e-mail računa",
  email_no_accounts_hint: "Povežite e-mail račun u postavkama profila",
  email_no_messages: "Nema e-mailova",
  email_from: "Od",
  email_to: "Za",
  email_subject: "Predmet",
  email_disconnect: "Odspoji",
  email_disconnect_confirm: "Jeste li sigurni da želite odspojiti ovaj e-mail račun? Svi sinkronizirani e-mailovi bit će uklonjeni.",
  email_account_disconnected: "Račun e-pošte uspješno odpojen",
  email_account_disconnect_failed: "Nije moguće odspojiti račun",
  email_connecting: "Povezivanje...",
  email_account_connected: "Račun uspješno povezan",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Idi na postavke",
  email_date: "Datum",
  email_reply: "Odgovori",
  email_forward: "Proslijedi",
  email_copy_text: "Kopiraj tekst",
  email_text_copied: "Kopirano!",
  email_text_copy_failed: "Tekst nije moguće kopirati.",
  email_delete: "Izbriši",
  email_not_spam: "Nije spam",
  email_not_spam_success: "E-pošta premještena u pristiglu poštu.",
  email_not_spam_failed: "Premještanje u pristiglu poštu nije uspjelo.",
  email_delete_confirm: "Jeste li sigurni da želite obrisati ovu e-poštu?",
  email_delete_from_folder: "Jeste li sigurni da želite obrisati iz {folder}?",
  email_delete_permanent_from_folder:
    "Jeste li sigurni da želite trajno obrisati iz {folder}? Ova se radnja ne može poništiti.",
  email_save_draft_confirm: "Želite li spremiti ovu e-poštu kao skicu?",
  email_save_draft: "Spremi skicu",
  email_discard: "Odbaci",
  email_back_to_compose: "Natrag na pisanje",
  email_draft_saved: "Skica spremljena.",
  email_draft_save_failed: "Spremanje skice nije uspjelo.",
  email_loading: "Učitavanje e-mailova...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Odaberi",
  email_attachment_singular: "Privitak",
  email_attachment_plural: "Privici",
  email_back: "Natrag",
  email_download: "Preuzmi",
  email_close: "Zatvori",
  email_preview: "Pregled",
  email_preview_not_available: "Pregled nije dostupan",
  email_preview_failed: "Pregled nije dostupan",
  select_attachments: "Odaberi privitke",
  email_loading_preview: "Učitavanje pregleda...",
  email_mark_unread_failed: "e-mail(ovi) nisu mogli biti označeni kao nepročitani.",
  email_delete_failed: "e-mail(ovi) nisu mogli biti izbrisani.",
  filter_all: "Sve",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Izravne poruke",
  my_notes: "My Space",
  filter_internal_groups: "Interni grupni chatovi",
  filter_external_groups: "Eksterni grupni chatovi",
  filter_group_chats: "Grupni chatovi",
  filter_groups_internal: "Interni",
  filter_groups_external: "Eksterni",
  filter_unread_only: "Samo nepročitano",
  room_daily_briefing_info: "Ako je uključeno, izvještaj za ovaj projekt se generira svakih 24 sata u vrijeme navedeno u osobnim postavkama — ali samo ako je u tom razdoblju bilo aktivnosti.",
  email_select_all: "Odaberi sve",
  email_deselect_all: "Poništi odabir",
  email_reply_all: "Odgovori svima",
  email_reply_placeholder: "Upišite odgovor...",
  email_forward_placeholder: "Dodajte poruku...",
  email_edit_draft: "Uredi skicu",
  email_attach: "Priloži",
  email_attachment_from_original: "Iz izvorne poruke",
  email_remove: "Ukloni",
  email_drop_files: "Ispustite datoteke za prilaganje",
  email_loading_attachments: "Učitavanje privitaka...",
  email_archive: "Arhiviraj",
  mark_unread: "Označi kao nepročitano",
  mark_read: "Označi kao pročitano",
  email_all_accounts: "Svi računi",
  email_error: "Greška",
  email_delete_email_failed: "Brisanje e-pošte nije uspjelo.",
  enter_url: "Unesite URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Pretplati se sada',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MJESEC BESPLATNOG PROBNOG RAZDOBLJA',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Danas nema plaćanja. Podaci kreditne kartice ne traže se prije početka plaćene pretplate.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Upravljajte svim e-mail računima izravno u Kjuupu',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI piše odgovore – vi samo potvrđujete',
  kjuup_io_feature_tasks: 'Zadaci i kalendar uvijek automatski ažurni',
  kjuup_io_choose_plan: 'Odaberite plan',
  kjuup_io_plan_monthly: 'Mjesečno',
  kjuup_io_plan_yearly: 'Godišnje',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Zaštićeno uslugom Stripe · otkažite bilo kada',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Plaćanje primljeno. Pretplata se aktivira…',
  kjuup_io_toast_activating_soon: 'Plaćanje primljeno. Vaša pretplata uskoro će biti aktivirana.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Preostalo {count} h',
  kjuup_io_trial_left_hour: 'Preostao 1 sat',
  kjuup_io_trial_left_minutes: 'Preostalo {count} min',
  kjuup_io_trial_left_minute: 'Preostala 1 minuta',
  kjuup_io_trial_left_seconds: 'Preostalo {count} s',
  kjuup_io_trial_left_second: 'Preostala 1 sekunda',
  kjuup_io_trial_ending_now: 'Probno razdoblje završava…',
  kjuup_io_request_timeout: 'Veza je istekla. Pokušajte ponovno.',
  kjuup_io_info_days_free: '{days} dana potpuno besplatno – pretplata počinje tek nakon probnog razdoblja.',
  kjuup_io_discount_total: 'Vaš popust: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Osobni: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Zatvori',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Vaše besplatno probno razdoblje je završilo',
  kjuup_io_trial_ended_body: 'Pretplatite se na Kjuup.io kako biste i dalje koristili e-poštu i ostale premium funkcije.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Vaše besplatno probno razdoblje je započelo',
  kjuup_io_toast_trial_fail: 'Probno razdoblje nije moguće pokrenuti',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / mjesec',
  kjuup_io_save_amount_year: 'Uštedite {price} godišnje',
  kjuup_io_billed_annually_amount: '{price} naplaćeno godišnje',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Što dobivate:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kreditna kartica nije potrebna – počnite odmah bez podataka o plaćanju.',
  kjuup_io_info_cancel_anytime: 'Otkažite bilo kada – bez obveze, bez rizika.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Obračunsko razdoblje',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Način plaćanja spremljen. Naplata slijedi na kraju probnog razdoblja.',
  calendar_sync_info: 'Automatski sinkroniziraj sve Kjuup ToDo zadatke s kalendarom.',
  calendar_no_accounts: 'Još nije povezan nijedan kalendar.',
  article_new_badge: 'NOVO',
  article_new_posts: '{0} novih objava',
  documents: 'Dokumenti',
  add_documents: 'Dodaj dokumente',
  no_preview_available: 'Pregled nije dostupan',
  no_preview_hint: 'Ova vrsta datoteke ne može se pregledati, ali će svejedno biti poslana.',
  max_documents_reached: 'Možete priložiti najviše 10 dokumenata odjednom.',
  open_file: 'Otvori datoteku',
  twofa_title: 'Dvofaktorska autentifikacija',
  twofa_method_totp: 'Aplikacija za autentifikaciju',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Unesi 6-znamenkasti kod iz aplikacije.',
  twofa_enter_sms: 'Unesi 6-znamenkasti kod koji smo poslali SMS-om.',
  twofa_enter_email: 'Unesi 6-znamenkasti kod koji smo poslali e-mailom.',
  twofa_resend: 'Pošalji kod ponovno',
  twofa_try_another: 'Druga metoda',
  twofa_remember_device: 'Ne pitaj na ovom uređaju 30 dana',
  twofa_sent: 'Poslali smo kod.',
  twofa_invalid_code: 'Taj kod nije točan. Pokušaj ponovno.',
  twofa_something_wrong: 'Nešto je pošlo po zlu. Pokušaj ponovno.',
  twofa_method_unavailable: 'Ta metoda nije dostupna.',
  twofa_on_desc: 'Dvofaktorska autentifikacija je uključena. Pri svakoj prijavi trebat ćeš kod.',
  twofa_off_desc: 'Dodaj drugi korak nakon lozinke. Aplikacije su najsigurnija opcija.',
  twofa_methods: 'Metode',
  twofa_on: 'Uključeno',
  twofa_add: 'Dodaj',
  twofa_default_method: 'Zadana metoda',
  twofa_default: 'Zadano',
  twofa_turn_off: 'Isključi',
  twofa_disable_hint: 'Unesi lozinku i trenutačni kod da isključiš dvofaktorsku autentifikaciju.',
  twofa_disable_need: 'Unesi lozinku i potvrdni kod.',
  twofa_code_placeholder: '6-znamenkasti ili rezervni kod',
  twofa_send_code: 'Pošalji kod',
  twofa_primary_updated: 'Zadana metoda je ažurirana.',
  twofa_disabled: 'Dvofaktorska autentifikacija je isključena.',
  twofa_enabled: 'Dvofaktorska autentifikacija je sada uključena.',
  twofa_totp_help: 'Skeniraj ovaj QR kod u Google Authenticatoru, Authyju ili 1Passwordu. Ključ možeš unijeti i ručno.',
  twofa_secret_copied: 'Ključ je kopiran',
  twofa_sms_help: 'Unesi broj u međunarodnom formatu. Poslat ćemo 6-znamenkasti kod SMS-om.',
  twofa_email_help: 'Poslat ćemo 6-znamenkasti kod na e-mail računa.',
  twofa_backup_title: 'Rezervni kodovi',
  twofa_backup_help: 'Spremi ove jednokratne kodove na sigurno. Svaki kod koristi se jednom ako izgubiš telefon.',
  twofa_copy_codes: 'Kopiraj kodove',
  twofa_codes_copied: 'Rezervni kodovi su kopirani',
  twofa_regenerate: 'Dohvati nove rezervne kodove',
  twofa_regenerate_hint: 'Ovo zamjenjuje neiskorištene rezervne kodove. Unesi lozinku i trenutačni kod.',
  twofa_backup_remaining: 'Preostalo je {n} neiskorištenih rezervnih kodova',
  twofa_new_codes: 'Novi rezervni kodovi',
  twofa_sms_unavailable: 'SMS kodovi još nisu dostupni.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Dodijeljeni Kjuup zadaci kopiraju se u projekt Kjuup u tvom Todoistu. Promjene u Todoistu ne kopiraju se natrag.",
  todoist_connect: "Poveži Todoist",
  todoist_connected: "Todoist je povezan",
  todoist_connect_failed: "Povezivanje s Todoistom nije uspjelo",
  todoist_disconnect: "Prekini vezu",
  todoist_disconnected: "Todoist je odspojen",
  todoist_disconnect_confirm: "Prekinuti vezu s Todoistom? Zadaci koji su već u Todoistu ostaju. Sinkronizacija staje.",
  todoist_sync_now: "Sinkroniziraj sada",
  todoist_syncing: "Sinkronizacija…",
  todoist_sync_done: "Sinkronizacija je gotova",
  todoist_sync_failed: "Sinkronizacija nije uspjela",
  todoist_auth_error: "Ponovno poveži Todoist da bi sinkronizacija nastavila.",
  todoist_last_sync: "Zadnja sinkronizacija",
  todoist_not_connected: "Todoist nije povezan",
  todoist_auth_url_failed: "Stranica za autorizaciju Todoista nije se mogla otvoriti.",
  recommend_text: "Pridruži se Kjuupu, ostani povezan i drži svoju komunikaciju organiziranom. Okupi svoje kanale, drži poruke u pravim projektima i započni svako jutro sa sažetkom i svojim zadacima – sve sinkronizirano s aplikacijama koje već koristiš. Započni besplatno:",
  pro_auth_signin_title: 'Dobro došli natrag',
  pro_auth_signin_sub: 'Prijavite se svojim poslovnim e-mailom.',
  pro_auth_email_or_username: 'E-mail ili korisničko ime',
  pro_auth_email_placeholder: 'ime@tvrtka.hr',
  pro_auth_forgot_password: 'Zaboravili ste lozinku?',
  pro_auth_create_account: 'Kreiraj račun',
  pro_auth_show_password: 'Prikaži lozinku',
  pro_auth_hide_password: 'Sakrij lozinku',
  pro_auth_register_sub: 'Poslat ćemo vam poveznicu za potvrdu e-maila.',
  pro_auth_register_plus_sub: 'Odaberite korisničko ime i lozinku. Zatim postavljate svoj sigurnosni PIN.',
  pro_auth_check_credentials: 'Provjerite svoj e-mail i lozinku',
  pro_news_export_pdf: 'Izvezi kao PDF',
  pro_news_pdf_failed: 'PDF nije moguće stvoriti.',
  pro_news_pdf_attachments: 'Privici',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Unesite svoj e-mail i poslat ćemo vam poveznicu za poništavanje lozinke.',
  pro_auth_send_link: 'Pošalji poveznicu za poništavanje',
  pro_auth_plus_reset: 'Poništi pomoću PIN-a',
  pro_auth_show_pin: 'Prikaži PIN',
  pro_auth_hide_pin: 'Sakrij PIN',
  v2_auth_plus_only: 'Samo Kjuup+',
  room_action_media: "Datoteke",
  room_tab_overview: "Pregled",
  room_tab_history: "Povijest",
  chat_info_media: "Datoteke",
  messages: "poruke",
  pro_todo_project_required: "Odaberite projekt",
  pro_todo_choose_project: "Za koji je projekt ovaj zadatak?",
  cockpit_report_delete_confirm: "Izbrisati ovo dnevno izvješće?",
  cockpit_report_deleted: "Dnevno izvješće izbrisano",
  cockpit_tab_company: "Tvrtka",
  cockpit_bookmarked_priorities: "Označeni zadaci",
  cockpit_load_error: "Kokpit se nije mogao učitati.",
  cockpit_retry: "Pokušaj ponovno",
  cockpit_yesterday: "Jučer",
  cockpit_greeting_morning: "Dobro jutro",
  cockpit_greeting_day: "Dobar dan",
  cockpit_greeting_evening: "Dobra večer",
  cockpit_assistant_q_open: "Što je danas otvoreno?",
  cockpit_assistant_q_summarize: "Sažmi chat {{room}}",
  cockpit_assistant_q_overdue: "Koji su zadaci prekoračeni?",
  cockpit_assistant_new: "{{n}} novih",
  cockpit_assistant_important: "{{n}} važnih",
  cockpit_assistant_title: "Kjuup asistent",
  cockpit_assistant_hint: "Dodirnite i pitajte",
  room_overview_priority_no_detail: "Izvješće ne navodi dodatne pojedinosti o ovom prioritetu.",
  room_overview_priority_from: "Izvor: {{name}}",
  room_overview_priority_open_task: "Otvori zadatak",
  cockpit_priority_position: "{{index}} od {{total}} prioriteta",
  room_overview_today_title: "Danas važno",
  room_overview_all_tasks: "Sve",
  room_overview_tasks_empty: "Nema otvorenih rokova ni zadataka",
  room_overview_appointments_empty: "Nema nadolazećih termina",
  room_overview_no_priorities: "Nema otvorenih prioriteta u zadnjem izvješću.",
  cockpit_report_top5: "Top 5 prioriteta",
  cockpit_report_todo_created: "Zadatak izrađen",
  cockpit_report_source_missing: "Izvorna poruka nije pronađena.",
  delete_bookmarked_priority_confirm: "Želite li doista izbrisati ovaj označeni zadatak?",
  cockpit_report_create_todo: "Izradi zadatak",
  cockpit_priorities_deleting: "Brisanje …",
  cockpit_priorities_select: "Izbriši više",
  cockpit_report_none: "Nema unosa.",
  cockpit_priorities_delete_confirm: "Želite li doista izbrisati {count} označenih zadataka?",
  cockpit_priorities_delete_failed: "Brisanje {count} zadataka nije uspjelo",
  cockpit_priorities_deleted: "Izbrisano zadataka: {count}",
  cockpit_priorities_selected: "Odabrano: {count}",
  cockpit_channel_connected: "Povezano",
  cockpit_channel_not_connected: "Nije povezano",
  cockpit_channel_connect: "Poveži",
  cockpit_channel_chat: "Kjuup chat",
  cockpit_channel_active: "Aktivno",
  cockpit_channel_hidden: "Skriveno",
  cockpit_channel_enable: "Omogući",
  cockpit_channel_email: "E-pošta",
  cockpit_channel_check: "Provjeri vezu",
  cockpit_channel_fix: "Provjeri",
  cockpit_channel_forward: "Adresa za prosljeđivanje",
  cockpit_channel_not_set_up: "Nije postavljeno",
  cockpit_channel_set_up: "Postavi",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Veza prekinuta",
  cockpit_channel_importing: "Uvoz u tijeku",
  cockpit_channel_removing: "Prekidanje veze",
  cockpit_channel_reconnect: "Ponovno poveži",
  cockpit_channels_title: "Kanali",
  cockpit_company_role_super_admin: "Administrator tvrtke",
  cockpit_company_role_dept_admin: "Administrator odjela",
  cockpit_company_role_member: "Zaposlenik",
  cockpit_company_none: "Nije pronađena Kjuup+ tvrtka",
  cockpit_company_eyebrow: "Tvrtka",
  cockpit_company_inactive: "neaktivno",
  cockpit_company_settings: "Postavke tvrtke",
  cockpit_company_employees: "Zaposlenici",
  cockpit_company_internal_rooms: "Interni projekti",
  cockpit_report_all_projects: "Svi projekti",
  cockpit_report_progress_emails: "Analiza e-poruka",
  cockpit_report_progress_chats: "Analiza poruka chata",
  cockpit_report_progress_documents: "Analiza privitaka i dokumenata",
  cockpit_report_progress_tasks: "Analiza zadataka",
  cockpit_report_progress_summarizing: "Analiza sadržaja",
  cockpit_report_progress_reading: "Ponovno korištenje već analiziranog sadržaja",
  cockpit_report_progress_collecting: "Prikupljanje e-poruka, chatova i zadataka iz vaših projekata",
  cockpit_report_progress_priorities: "Sastavljanje prioriteta, rokova i odluka",
  cockpit_report_progress_queued: "Priprema izvješća",
  cockpit_report_creating_title: "Vaše dnevno izvješće se priprema",
  cockpit_report_progress_count_one: "Analizirana 1 stavka",
  cockpit_report_progress_count_many: "Analizirano stavki: {{count}}",
  cockpit_report_progress_hint: "Obično traje jednu do dvije minute – u međuvremenu možete nastaviti koristiti kokpit.",
  cockpit_report_time_hint: "Dnevno izvješće izrađuje se svaki dan u {{hour}}:00 za pet najaktivnijih projekata.",
  room_overview_priorities_title: "Trenutno stanje i prioriteti",
  room_overview_as_of: "Stanje: {{time}}",
  cockpit_report_delete: "Izbriši dnevno izvješće",
  email_tag_daily_briefing: "Dnevno izvješće",
  cockpit_report_unread: "Novo",
  cockpit_report_clear_project: "Prikaži sve projekte",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Svi projekti",
  cockpit_report_recreate: "Ponovno izradi dnevno izvješće",
  cockpit_report_hide_previous: "Sakrij prethodna dnevna izvješća",
  cockpit_report_show_previous: "Prikaži prethodna dnevna izvješća",
  cockpit_report_room_empty: "Još nema dnevnog izvješća za ovaj projekt",
  cockpit_report_empty: "Još nema dnevnog izvješća",
  cockpit_report_room_empty_hint: "Izradite dnevno izvješće samo za ovaj projekt.",
  cockpit_report_needs_mailbox: "Povežite račun e-pošte kako bi Kjuup mogao izraditi dnevno izvješće s automatskim zadacima.",
  cockpit_report_create: "Izradi dnevno izvješće",
  cockpit_email_connect: "Poveži e-poštu",
  cockpit_email_none_title: "Još nije povezan račun e-pošte",
  cockpit_email_none_reports: "Povežite svoj poštanski sandučić kako bi Kjuup dolazne e-poruke razvrstao u vaše projekte i iz njih izradio dnevna izvješća sa zadacima.",
  cockpit_email_none_client: "Povežite Gmail, Outlook ili IMAP za čitanje, razvrstavanje i odgovaranje na e-poruke izravno u Kjuup.io.",
  cockpit_email_reports_title: "Dosadašnji klijent e-pošte",
  cockpit_email_reports_text: "Nema sandučića u Kjuup.io · {{rooms}} projekata s dnevnim izvješćem u {{hour}}:00 · dolazne e-poruke razvrstavaju se u vaše projekte.",
  cockpit_email_reports_rooms: "Upravljaj projektima",
  cockpit_email_settings: "Postavke e-pošte",
  cockpit_email_error_title: "Provjeri vezu",
  cockpit_email_client_title: "Prijem postavljen",
  cockpit_email_accounts_n: "Povezanih računa: {{n}}",
  cockpit_email_last_sync: "zadnja sinkronizacija {{when}}",
  cockpit_email_report_at: "Dnevno izvješće u {{hour}}:00",
  cockpit_email_open_inbox: "Otvori sandučić",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Povezane adrese e-pošte",
  email_folder_sent: "Poslano",
  email_no_subject: "(Bez predmeta)",
  cockpit_email_detail_loading: "Učitavanje e-pošte …",
  cockpit_email_detail_failed: "E-poruka se nije mogla učitati.",
  cockpit_email_detail_empty: "Ova e-poruka nema teksta.",
  cockpit_personal_settings: "Osobne postavke",
  cockpit_companies: "Tvrtke",
  cockpit_title: "Kokpit",
  cockpit_back: "Natrag na pregled",
  cockpit_day_overview: "Vaš dan na prvi pogled",
  email_saved_to_project: "E-poruka spremljena u projekt",
  email_classify_need_project: "Unesite naziv projekta",
  cockpit_email_deleted: "E-poruka izbrisana",
  cockpit_email_sent_empty: "Još nema poslanih e-poruka.",
  cockpit_email_incoming_empty: "Još nema primljenih e-poruka.",
  cockpit_email_incoming_title: "E-poruke",
  cockpit_email_incoming_sub: "Razvrstajte dolazne i poslane e-poruke u svoje projekte. Razvrstavanje možete prilagoditi ovdje.",
  cockpit_email_incoming_unassigned_n: "Nerazvrstano: {{n}}",
  cockpit_email_folder_inbox: "Pristigla pošta",
  cockpit_email_folder_sent: "Poslano",
  cockpit_email_open: "Otvori e-poruku",
  cockpit_email_incoming_suggested: "Prijedlog: {{room}}",
  cockpit_email_incoming_apply: "Primijeni",
  cockpit_email_incoming_adjust: "Prilagodi razvrstavanje",
  cockpit_email_incoming_saving: "Spremanje …",
  cockpit_email_incoming_unassigned: "Nerazvrstano",
  cockpit_email_incoming_show_less: "Prikaži manje",
  cockpit_email_incoming_show_all: "Prikaži svih {{n}}",
  cockpit_io_settings: "Postavke Kjuup.io",
  cockpit_io_settings_sub: "Paket i mjesta, dodjela zaposlenika, naplata i računi.",
  products_coming_soon: "Uskoro dostupno",
  cockpit_upsell_io_title: "Vaš ured koji razmišlja s vama",
  cockpit_upsell_io_text: "Povežite svoje račune e-pošte s Kjuupom. E-poruke, privici i poruke automatski se spremaju u odgovarajući projekt i po želji se mogu pohraniti na vaš poslužitelj. Svaki dan dobivate sažetak svih projekata s najvažnijim točkama iz svih sadržaja, a vaši se zadaci sinkroniziraju s kalendarom ili aplikacijom za zadatke.",
  cockpit_upsell_io_soon_title: "Još nije moguće naručiti",
  cockpit_upsell_io_soon_text: "Kjuup.io uskoro počinje. Zatražite informacije – javit ćemo vam se čim budete mogli naručiti Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planirana cijena",
  cockpit_upsell_io_cta_request: "Zatraži informacije",
  kjuup_plus_abo_per_year: "/ godina",
  kjuup_plus_abo_per_month: "/ mjesec",
  kjuup_plus_abo_status_active: "Aktivno",
  kjuup_plus_abo_status_requested: "Otkazivanje zatraženo",
  kjuup_plus_abo_status_past_due: "Plaćanje dospjelo",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Pretplata",
  kjuup_plus_abo_title: "Kjuup+ paket",
  kjuup_plus_abo_seats_free_one: "Još 1 slobodno mjesto",
  kjuup_plus_abo_billing: "Način plaćanja",
  kjuup_plus_abo_yearly: "Godišnje",
  kjuup_plus_abo_monthly: "Mjesečno",
  kjuup_plus_abo_amount: "Iznos",
  kjuup_plus_abo_ends: "Završava",
  kjuup_plus_abo_renews: "Sljedeće produljenje",
  kjuup_plus_abo_next_invoice: "Sljedeći račun",
  kjuup_plus_abo_intro: "Uvodna cijena",
  kjuup_plus_abo_pending_tier: "Od sljedećeg produljenja",
  kjuup_plus_abo_manual: "Kjuup+ je za vašu tvrtku aktivan prema individualnom dogovoru.",
  kjuup_plus_abo_invoices: "Računi",
  kjuup_plus_abo_invoice_paid: "Plaćeno",
  kjuup_plus_abo_invoice_view: "Prikaži",
  kjuup_plus_abo_invoices_less: "Prikaži manje",
  kjuup_plus_abo_member_hint: "Naplatu i otkazivanje upravljaju administratori tvrtke.",
  kjuup_plus_abo_withdraw: "Povuci zahtjev",
  kjuup_plus_abo_cancel_note: "Razlog (neobavezno)",
  kjuup_plus_abo_cancel_send: "Zatraži otkazivanje",
  kjuup_plus_abo_cancel: "Otkaži pretplatu",
  cockpit_upsell_plus_f1: "Upravljajte komunikacijskim aktivnostima svih zaposlenika",
  cockpit_upsell_plus_f2: "Obavještavajte određene skupine korisnika unutar tvrtke",
  cockpit_upsell_plus_f3: "Spremajte interne grupne chatove",
  cockpit_upsell_plus_when_yearly: "uz godišnje plaćanje",
  cockpit_upsell_plus_size_small: "1–50 zaposlenika",
  cockpit_upsell_plus_size_large: "51–200 zaposlenika",
  cockpit_upsell_plus_title: "Kjuup+ za tvrtke",
  cockpit_upsell_plus_text: "Upravljajte zaposlenicima, pravima pisanja i komunikacijom tvrtke na jednom mjestu. Interni kanali ostaju kod vaših zaposlenika, vanjski kanali povezuju vas s projektnim partnerima, a određene skupine obavještavate ciljano. Uz Kjuup+ možete naručiti Kjuup.io pristupe za skupine zaposlenika. Kjuup+ i Kjuup.io mogu se kombinirati.",
  cockpit_upsell_plus_size: "Veličina tvrtke",
  cockpit_upsell_plus_billing: "Način plaćanja",
  cockpit_upsell_plus_per_company: "/ tvrtka · mjesec bez PDV-a",
  cockpit_upsell_plus_onboarding: "Troškovi uvođenja ovise o veličini tvrtke",
  cockpit_upsell_plus_larger: "Cijene za veće tvrtke na upit",
  cockpit_upsell_plus_cta: "Nezavezujući upit",
  cockpit_kpi_deadlines_tasks: "Rokovi i zadaci",
  cockpit_kpi_appointments: "Termini",
  cockpit_room_admin: "Upravljanje projektima i chatovima",
  cockpit_room_admin_sub: "Svi projekti tvrtke s članovima, medijima i chatovima.",
  pro_todo_not_found: "Ovaj zadatak više nije dostupan.",
  cockpit_chip_overdue: "Prekoračeno",
  cockpit_chip_today: "Danas",
  cockpit_calendar_week: "{{week}}. tjedan",
  cockpit_prev_week: "Prethodni tjedan",
  cockpit_next_week: "Sljedeći tjedan",
  cockpit_chip_requested: "Zatraženo",
  cockpit_todo_due: "Rok {{when}}",
  cockpit_todo_at: "u {{time}}",
  cockpit_todo_requested_from: "od {{name}}",
  cockpit_todo_since: "od {{when}}",
  cockpit_todo_no_date: "Bez datuma",
  cockpit_todo_mark_done: "Označi kao dovršeno",
  cockpit_my_tasks_title: "Moji zadaci",
  cockpit_today_tasks_group: "Zadaci za danas",
  cockpit_assign_none: "Nitko nije dodijeljen",
  no_project_found: "Projekt nije pronađen",
  cockpit_row_more_actions: "Više radnji",
  needs_date: "Dodijeli termin",
  cockpit_assign_proposal: "Prepoznato: {{name}} – dodijeliti?",
  cockpit_assign_proposal_confirm: "Dodijeli",
  cockpit_assign_proposal_dismiss: "Zanemari",
  cockpit_priority_date: "Datum",
  todo_calendar_add: "Dodaj u kalendar",
  todo_calendar_remove: "Ukloni iz kalendara",
  cockpit_todo_change_project: "Promijeni projekt",
  cockpit_todo_set_date: "Postavi datum",
  pro_todo_done_confirm: "Želite li doista označiti ovaj zadatak kao dovršen?",
  cockpit_task_delete_failed: "Zadatak se nije mogao izbrisati.",
  cockpit_setup_title: "Dovršite postavljanje",
  cockpit_setup_text: "Odlučite želite li koristiti chatove i treba li Kjuup.io raditi kao klijent e-pošte ili samo s projektima i dnevnim izvješćima.",
  cockpit_setup_cta: "Postavi sada",
  cockpit_group_tasks: "Rokovi i zadaci",
  cockpit_group_appointments: "Termini",
  cockpit_report_no_activity: "U ovom projektu u zadnja 24 sata nije bilo novih poruka ni e-poruka.",
  cockpit_report_room_unavailable: "Ovaj projekt nije dostupan.",
  cockpit_report_create_failed: "Dnevno izvješće nije se moglo izraditi.",
  cockpit_report_created: "Dnevno izvješće izrađeno",
  addon_enable_confirm: "Omogućiti dodatak?",
  addon_enable: "Omogući",
  addon_enabled: "Dodatak omogućen",
  nav_email: "E-pošta",
  nav_my_cockpit: "Moj kokpit",
  nav_news: "Novosti",
  nav_recommend: "Preporuči",
  pro_todo_status_done: "Dovršeno",
  pro_todo_status_open: "Otvoreno",
  v2_todo_remove: "Ukloni",
  pro_todo_search_people: "Traži osobe",
  pro_todo_clear: "Poništi",
  pro_todo_assigned: "(dodijeljeno)",
  pro_todo_no_people: "Nema pronađenih osoba",
  pro_todo_search_rooms: "Traži projekte",
  pro_todo_no_rooms_match: "Nijedan projekt ne odgovara „{{q}}“",
  pro_todo_no_rooms: "Nema pronađenih projekata",
  pro_todo_activity: "Aktivnost",
  pro_todo_show_less: "Prikaži manje",
  pro_todo_show_all: "Prikaži sve ({{n}})",
  pro_todo_due: "Dospijeva",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Odaberi projekt",
  pro_todo_status: "Status",
  pro_todo_more: "Više",
  pro_todo_edit_title: "Uredi zadatak",
  pro_todo_description: "Opis",
  pro_todo_created_by: "Izradio/la",
  pro_todo_chat: "Chat",
  navigate_to_source: "Idi na izvor",
  todo_calendar_connect_title: "Nije povezan kalendar",
  todo_calendar_connect_body_web: "Povežite kalendar u postavkama sinkronizacije kalendara kako biste mu mogli dodavati zadatke.",
  todo_calendar_connect: "Poveži",
  todo_calendar_removed: "Uklonjeno iz vašeg kalendara",
  todo_calendar_added_later: "Dodano. Kalendar nije bio dostupan; Kjuup će pokušati ponovno kasnije.",
  todo_calendar_added: "Dodano u vaš kalendar",
  todo_calendar_no_date: "U kalendar se može dodati samo zadatak s datumom.",
  todo_calendar_failed: "Kalendar se nije mogao ažurirati. Pokušajte ponovno.",
  todo_calendar_date_title: "Još nema datuma",
  todo_calendar_date_save: "Postavi datum i dodaj",
  todo_calendar_date_body_web: "Ovaj označeni zadatak još nema datum. Postavite ga kako biste ga dodali u kalendar.",
  kjuup_io_setup_saved: "Postavljanje spremljeno",
  kjuup_io_setup_step: "Korak",
  kjuup_io_setup_chats_title: "Želite li koristiti chatove?",
  kjuup_io_setup_email_title: "Gdje želite čitati e-poštu?",
  kjuup_io_setup_chats_sub: "Chatovi s kolegama i projektnim partnerima neobavezni su. Možete ih u svakom trenutku prikazati ili sakriti u kokpitu.",
  kjuup_io_setup_email_sub: "Ovdje samo birate koristite li klijent e-pošte u Kjuupu ili i dalje radite sa svojim dosadašnjim programom, primjerice Outlookom ili drugim. Kasnije možete promijeniti.",
  kjuup_io_setup_chats_yes: "Da, prikaži chatove",
  kjuup_io_setup_chats_yes_text: "Poruke sadrže chatove i e-poštu. Projekti imaju grupne chatove za sve sudionike.",
  kjuup_io_setup_chats_no: "Ne, radi bez chatova",
  kjuup_io_setup_chats_no_text: "Chatovi su skriveni. „Poruke“ postaju „E-pošta“; projekti, zadaci i dnevna izvješća ostaju.",
  kjuup_io_setup_email_client: "Klijent e-pošte u Kjuupu",
  kjuup_io_setup_email_client_text: "Čitajte e-poštu i odgovarajte na nju izravno u Kjuupu.",
  kjuup_io_setup_email_reports: "Dosadašnji klijent e-pošte",
  kjuup_io_setup_email_reports_text: "E-poštu čitajte i odgovarajte na nju i dalje u svom trenutnom programu, primjerice Outlooku ili drugom.",
  kjuup_io_setup_skip: "Kasnije",
  next: "Dalje",
  kjuup_io_setup_finish: "Dovrši postavljanje",
  today_label: "danas",
  tomorrow_label: "sutra",
  cockpit_todo_overdue: "prekoračeno",
  cockpit_report_management_fazit: "Sažetak za upravu",
  cockpit_todo_appointment: "Termin",
  cockpit_todo_deadline: "Rok",
  cockpit_todo_deadline_define: "Odredi rok",
  pro_todo_status_acknowledged: "Potvrđeno",
  pro_todo_responsible: "Odgovoran",
  pro_todo_notice_confirmed: "Potvrđeno u chatu",
  pro_todo_notice_sent_at: "Poruka poslana",
  pro_todo_notice_again: "Ponovno pošalji poruku",
  pro_todo_notice_send: "Obavijesti Kjuup porukom",
  pro_todo_add_assignee: "Dodaj",
  pro_todo_edit: "Uredi",
  pro_todo_change_room: "Promijeni projekt",
  pro_todo_due_on: "Dospijeva dana",
  pro_todo_edit_due: "Uredi rok",
  pro_todo_no_date: "Bez datuma",
  pro_todo_edit_description: "Uredi opis",
  pro_todo_no_description: "Još nema opisa",
  pro_todo_title_label: "Naslov",
  pro_todo_title_placeholder: "Unesite naslov...",
  pro_todo_task: "Zadatak",
  pro_todo_what: "Što treba napraviti?",
  pro_todo_source_email: "E-pošta",
  pro_todo_sources: "Izvori",
  previous: "Prethodno",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (do {max} zaposlenika)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (do {max} zaposlenika)",
  kjuup_plus_abo_status_ends: "Završava {date}",
  kjuup_plus_abo_seats_over: "Više od {max} zaposlenika – Kjuup će vam se javiti s individualnom ponudom.",
  kjuup_plus_abo_seats_next: "Ako se pridruži više zaposlenika, paket se automatski mijenja u {next} (proporcionalni obračun).",
  kjuup_plus_abo_seats_used: "Zauzeta mjesta: {used} od {total}",
  kjuup_plus_abo_seats_free: "Slobodna mjesta: {count}",
  kjuup_plus_abo_intro_until: "do {date}",
  kjuup_plus_abo_invoice_open: "Otvoreno · dospijeva {date}",
  kjuup_plus_abo_invoices_all: "Prikaži sve ({count})",
  kjuup_plus_abo_requested_hint: "Otkazivanje zatraženo {date}. Kjuup ga potvrđuje na kraju ugovornog razdoblja ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup pregledava vaš zahtjev i potvrđuje otkazivanje na kraju ugovornog razdoblja ({end}). Do tada Kjuup+ ostaje aktivan.",
  kjuup_plus_abo_withdrawn: "Zahtjev za otkazivanje povučen",
  kjuup_plus_abo_requested: "Otkazivanje zatraženo",
  cockpit_upsell_plus_intro_hint: "prva {months} mjeseca, zatim {price}",
  cockpit_upsell_plus_badge: "UVODNA CIJENA ZA {months} MJESECA",
  calendar_syncing: "Ažuriranje iz kalendara…",
  calendar_sync_up_to_date: "Kalendar je ažuran",
  calendar_sync_failed: "Sinkronizacija nije uspjela",
  delete_multiple_tasks_confirm: "Jeste li sigurni da želite izbrisati {count} ToDo-a?",
  todos_deleted_count: "Izbrisano {count} ToDo-a",
  todos_deleted_partial: "Izbrisano {ok} ToDo-a, {fail} neuspjelih",
  todo_unknown: "Nepoznato",
  todo_created_from_message: "Zadatak izrađen iz ove poruke",
  kjuup_io_todo_calendar_trial_ended_note: "Sinkronizacija kalendara · Pretplatite se",
  kjuup_io_todo_calendar_nudge: "Sinkronizirati ovaj ToDo s vašim kalendarom?",
  kjuup_io_todo_calendar_nudge_cta: "Aktiviraj Kjuup.io",
  todo_confirmed: "ToDo potvrđeno",
  pro_todo_bulk_delete_title: "Izbrisati zadatke ({{n}})?",
  pro_todo_previous_none_own: "Zakašnjele zadatke dodijelili su vam drugi i samo ih oni mogu izbrisati.",
  pro_todo_previous_none: "Nema zakašnjelih zadataka",
  pro_todo_previous_title: "Izbrisati zakašnjele zadatke ({{n}})?",
  pro_todo_previous_text: "Svi vaši otvoreni zadaci iz prethodnih dana bit će izbrisani.",
  pro_todo_previous_skipped: "Zadaci koje su dodijelili drugi ostaju: {{n}}.",
  unassign_task_confirm: "Želite li poništiti svoju dodjelu za ovaj zadatak?",
  unassign_label: "Poništi",
  pro_todo_delete_title: "Izbriši zadatak",
  pro_todo_today: "Danas",
  pro_todo_yesterday: "Jučer",
  pro_todo_since_yesterday: "Od jučer",
  pro_todo_mark_open: "Označi kao otvoreno",
  verify_completion: "Potvrdi",
  new_label: "Novo",
  bookmarked_no_mylist: "Spremljeni zadaci ne mogu se dodati u Moj popis",
  delete_only_own: "Možete brisati samo zadatke koje ste sami izradili",
  todo_clear_all: "Obriši sve",
  pro_todo_of_completed: "Dovršeno {{done}} od {{total}}",
  pro_todo_pick_date: "Odaberite datum",
  pro_todo_show_day: "Prikaži dan",
  todo_adjust_list: "Prilagodi popis",
  pro_todo_section_upcoming: "Nadolazeće",
  pro_todo_section_done: "Završeno",
  pro_todo_room_empty_today: "Danas nema zadataka u ovom projektu",
  pro_todo_room_empty_day: "Na taj dan nema zadataka u ovom projektu",
  pro_todo_delete_previous: "Izbriši sve",
  todo_my_list_empty: "Tvoj dan je prazan",
  todo_my_list_empty_hint: "Kliknite „Prilagodi popis” kako biste dodali zadatke",
  pro_todo_empty_title: "Ovdje nema ničega",
  pro_todo_empty_hint: "Nijedan zadatak ne odgovara ovom prikazu.",
  pro_todo_selected: "Odabrano: {{n}}",
  delete_selected_count: "Izbriši ({count})",
  pro_todo_adjust_done: "Gotovo",
  pro_todo_deleting: "Brisanje...",
  pro_todo_reopen: "Ponovno otvori zadatak",
  pro_todo_step_done: "Obavljeno",
  move_back_in_progress: "Vrati u tijek",
  pro_todo_mark_not_started: "Označi kao nije započeto",
  back_into_in_progress: "Vrati u tijek",
  pro_todo_mark_in_progress: "Označi kao u tijeku",
  unassign_todo: "Poništi dodjelu ToDo",
  pro_todo_open_room: "Otvori projekt",
  pro_todo_new_task: "Novi zadatak",
  select_user_back_to_in_progress: "Odaberite korisnika kojeg želite vratiti u tijek",
  cockpit_email_accounts_n_many: "Povezani računi: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup kontakti",
  combined_tab_teams: "Teams kontakti",
  combined_bridge_failed: "Kopiju u Teamsu nije bilo moguće stvoriti.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup i Teams kontakti: stvara se nova grupa koja se prikazuje i u Microsoft Teamsu.",
  teams_new_chat_title: "Novi Teams chat",
  teams_new_chat_topic: "Naziv grupe (neobavezno)",
  teams_new_chat_start: "Pokreni chat",
  teams_new_chat_creating: "Stvaranje chata…",
  teams_new_chat_forbidden: "Microsoft Teams ne dopušta ovaj chat (npr. osoba izvan tvoje organizacije ili pravilo tvoje IT službe).",
  teams_new_chat_too_many: "Previše osoba za jedan chat.",
  teams_new_chat_type_hint: "Upiši ime za pretraživanje u svojoj organizaciji.",
  teams_new_chat_directory_forbidden: "Tvoja organizacija ne dopušta pretraživanje imenika. Prikazuju se samo osobe iz tvojih Teams chatova.",
  teams_new_chat_account: "Račun",
};
